import styled from 'styled-components';
const StyledTableCell = styled.td`
  padding: 16px;
  color: #495057;
  border-bottom: 1px solid #dee2e6;

  .info-box{
    display: flex;
    flex-direction: column;
    gap: 3px;
    font-size: 12px;
    font-weight: 600;
  }
`

export function TdReceiverInfo({
    returnExchange
}) {
    return (
        <>
            <StyledTableCell>
                <div className='info-box'>
                    <div>수취인명: {returnExchange?.receiver}</div>
                    <div>전화번호1: {returnExchange?.receiverContact1}</div>
                    <div>전화번호2: {returnExchange?.receiverContact2 || '-'}</div>
                </div>
            </StyledTableCell>
        </>
    );
}